import { algoliaClient } from './algolia-search-client';
import { getAlgoliaKeys, getAlgoliaKeysIfAvailable } from './algolia-keys-service';

// Cache for people index keys to avoid repeated fetches when keys aren't provided
let cachedPeopleIndexKeys = null;
let peopleIndexKeysPromise = null;
// Cache the actual people index instance to avoid creating multiple instances
let cachedPeopleIndex = null;
let cachedPeopleIndexKeysForInstance = null;

const getProjectIndex = async (filter, keys) => {
  // If keys not provided or incomplete, fetch them
  let algoliaKeys = keys;
  if (!algoliaKeys?.appId || !algoliaKeys?.searchApiKey) {
    try {
      algoliaKeys = await getAlgoliaKeys();
    } catch (error) {
      // If getAlgoliaKeys throws (e.g., backend unavailable), return null for graceful degradation
      console.warn('[Algolia] Failed to fetch keys for project index:', error);
      return null;
    }
  }
  
  // Return null instead of throwing to maintain backward compatibility and allow graceful degradation
  // searchClient handles null indices by returning empty results
  if (!algoliaKeys?.appId || !algoliaKeys?.searchApiKey) {
    console.warn('[Algolia] Algolia keys not available for project index. Returning null for graceful degradation.');
    return null;
  }
  const client = algoliaClient(algoliaKeys.appId, algoliaKeys.searchApiKey);
  if (filter.sort['Name'] === 1) return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_NAME_ASC || '');
  if (filter.sort['Name'] === -1) return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_NAME_DESC || '');
  if (filter.sort['Type'] === 1) return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_TYPE_ASC || '');
  if (filter.sort['Type'] === -1) return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_TYPE_DESC || '');
  if (filter.sort['Production'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_PRODUCTION_ASC || '');
  if (filter.sort['Production'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_PRODUCTION_DESC || '');
  if (filter.sort['Network'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_NETWORK_ASC || '');
  if (filter.sort['Network'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_NETWORK_DESC || '');
  if (filter.sort['Studio'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_STUDIO_ASC || '');
  if (filter.sort['Studio'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_STUDIO_DESC || '');
  if (filter.sort['Director'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_DIRECTOR_ASC || '');
  if (filter.sort['Director'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_DIRECTOR_DESC || '');
  if (filter.sort['Talent'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_TALENT_ASC || '');
  if (filter.sort['Talent'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_TALENT_DESC || '');
  if (filter.sort['Literary'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_LITERARY_ASC || '');
  if (filter.sort['Literary'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_LITERARY_DESC || '');
  if (filter.sort['State'] === 1) return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_STATE_ASC || '');
  if (filter.sort['State'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_STATE_DESC || '');
  if (filter.sort['Classification'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_CLASSIFICATION_ASC || '');
  if (filter.sort['Classification'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_CLASSIFICATION_DESC || '');
  if (filter.sort['Genre'] === 1) return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_GENRE_ASC || '');
  if (filter.sort['Genre'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_GENRE_DESC || '');
  if (filter.sort['Capacity'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_CAPACITY_ASC || '');
  if (filter.sort['Capacity'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_CAPACITY_DESC || '');
  if (filter.sort['Promoters'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_PROMOTERS_ASC || '');
  if (filter.sort['Promoters'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_PROMOTERS_DESC || '');
  if (filter.sort['Agent'] === 1) return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_AGENT_ASC || '');
  if (filter.sort['Agent'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_AGENT_DESC || '');
  if (filter.sort['Created'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_CREATED_ASC || '');
  if (filter.sort['Created'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_CREATED_DESC || '');
  if (filter.sort['Updated'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_UPDATED_ASC || '');
  if (filter.sort['Updated'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_UPDATED_DESC || '');
  if (filter.sort['Start'] === 1) return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_START_ASC || '');
  if (filter.sort['Start'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_START_DESC || '');
  if (filter.sort['Placements'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_PLACEMENTS_ASC || '');
  if (filter.sort['Placements'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_INDEX_PLACEMENTS_DESC || '');

  // If we got here, we don't have an index mapping for the provided sort.
  // Return null instead of throwing to allow graceful fallback in callers.
  // This maintains backward compatibility with code that may have relied on undefined behavior.
  console.warn(`[Algolia] Unsupported project sort for Algolia index: ${JSON.stringify(filter?.sort)}. Returning null.`);
  return null;
};

const getCastingIndex = async (filter, keys) => {
  // If keys not provided or incomplete, fetch them
  let algoliaKeys = keys;
  if (!algoliaKeys?.appId || !algoliaKeys?.searchApiKey) {
    try {
      algoliaKeys = await getAlgoliaKeys();
    } catch (error) {
      // If getAlgoliaKeys throws (e.g., backend unavailable), return null for graceful degradation
      console.warn('[Algolia] Failed to fetch keys for casting index:', error);
      return null;
    }
  }
  
  // Return null instead of throwing to maintain backward compatibility and allow graceful degradation
  // searchClient handles null indices by returning empty results
  if (!algoliaKeys?.appId || !algoliaKeys?.searchApiKey) {
    console.warn('[Algolia] Algolia keys not available for casting index. Returning null for graceful degradation.');
    return null;
  }
  const client = algoliaClient(algoliaKeys.appId, algoliaKeys.searchApiKey);
  if (filter.sort['Project'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_NAME_ASC || '');
  if (filter.sort['Project'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_NAME_DESC || '');
  if (filter.sort['name'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_ROLE_ASC || '');
  if (filter.sort['name'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_ROLE_DESC || '');
  if (filter.sort['roleType'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_ROLETYPE_ASC || '');
  if (filter.sort['roleType'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_ROLETYPE_DESC || '');
  if (filter.sort['talent'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_TALENT_ASC || '');
  if (filter.sort['talent'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_TALENT_DESC || '');
  if (filter.sort['executives'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_EXECUTIVES_ASC || '');
  if (filter.sort['executives'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_EXECUTIVES_DESC || '');
  if (filter.sort['agents'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_AGENTS_ASC || '');
  if (filter.sort['agents'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_AGENTS_DESC || '');
  if (filter.sort['Created'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_CREATED_ASC || '');
  if (filter.sort['Created'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_CREATED_DESC || '');
  if (filter.sort['Updated'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_UPDATED_ASC || '');
  if (filter.sort['Updated'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_UPDATED_DESC || '');
  if (filter.sort['Start'] === 1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_START_ASC || '');
  if (filter.sort['Start'] === -1)
    return client.initIndex(process.env.REACT_APP_ALGOLIA_PROJECTS_CASTINGS_INDEX_START_DESC || '');

  // If we got here, we don't have an index mapping for the provided sort.
  // Return null instead of throwing to allow graceful fallback in callers.
  // This maintains backward compatibility with code that may have relied on undefined behavior.
  console.warn(`[Algolia] Unsupported casting sort for Algolia index: ${JSON.stringify(filter?.sort)}. Returning null.`);
  return null;
};

const getPeopleIndex = async (keys) => {
  // If keys not provided, incomplete, or empty object, use cached keys or fetch them
  // Treat empty object {} the same as undefined/null to avoid unnecessary fetches
  let algoliaKeys = keys;
  if (!algoliaKeys || !algoliaKeys.appId || !algoliaKeys.searchApiKey) {
    // Use cached keys if available and have sufficient buffer time remaining
    // We check buffer time to prevent using keys that might expire during request execution
    if (cachedPeopleIndexKeys?.appId && cachedPeopleIndexKeys?.searchApiKey) {
      const now = Date.now();
      const expiresAt = cachedPeopleIndexKeys.expiresAt;
      // Use cached keys only if they have sufficient buffer time (60 seconds) remaining
      // This matches the manager's "fresh enough" logic to ensure consistency
      const REFRESH_BUFFER_MS = 60 * 1000; // Match manager's refreshBufferMs
      if (expiresAt && expiresAt > now && expiresAt - now > REFRESH_BUFFER_MS) {
        algoliaKeys = cachedPeopleIndexKeys;
      } else {
        // Cached keys expired or don't have enough buffer time, clear cache
        cachedPeopleIndexKeys = null;
        cachedPeopleIndex = null;
        cachedPeopleIndexKeysForInstance = null;
      }
    }
    
    // If we don't have valid cached keys, try to get them from manager without forcing refresh
    if (!algoliaKeys || !algoliaKeys.appId || !algoliaKeys.searchApiKey) {
      // First, try to get keys from manager without forcing refresh (if they exist and have sufficient buffer time)
      const managerKeys = getAlgoliaKeysIfAvailable();
      if (managerKeys?.appId && managerKeys?.searchApiKey) {
        algoliaKeys = managerKeys;
        cachedPeopleIndexKeys = managerKeys;
      } else {
        // No valid keys available, fetch them (with deduplication)
        if (!peopleIndexKeysPromise) {
          peopleIndexKeysPromise = (async () => {
            try {
              const fetchedKeys = await getAlgoliaKeys();
              if (fetchedKeys?.appId && fetchedKeys?.searchApiKey) {
                cachedPeopleIndexKeys = fetchedKeys;
              }
              return fetchedKeys;
            } catch (error) {
              // If getAlgoliaKeys throws (e.g., backend unavailable), return null for graceful degradation
              console.warn('[Algolia] Failed to fetch keys for people index:', error);
              return null;
            } finally {
              peopleIndexKeysPromise = null;
            }
          })();
        }
        try {
          algoliaKeys = await peopleIndexKeysPromise;
        } catch (error) {
          // Handle case where promise itself rejects
          console.warn('[Algolia] Error getting keys for people index:', error);
          algoliaKeys = null;
        }
      }
    }
  } else {
    // Cache valid keys that were passed in (they should have expiresAt from manager)
    cachedPeopleIndexKeys = algoliaKeys;
  }
  
  // Return null instead of throwing to maintain backward compatibility and allow graceful degradation
  // searchClient handles null indices by returning empty results
  if (!algoliaKeys?.appId || !algoliaKeys?.searchApiKey) {
    console.warn('[Algolia] Algolia keys not available for people index. Returning null for graceful degradation.');
    return null;
  }
  
  // Check if we can reuse cached index instance (same keys)
  const keysMatch = cachedPeopleIndexKeysForInstance?.appId === algoliaKeys.appId && 
                    cachedPeopleIndexKeysForInstance?.searchApiKey === algoliaKeys.searchApiKey;
  if (cachedPeopleIndex && keysMatch) {
    return cachedPeopleIndex;
  }
  
  // Create new index instance and cache it
  const client = algoliaClient(algoliaKeys.appId, algoliaKeys.searchApiKey);
  if (!client) return null;
  const index = client.initIndex(process.env.REACT_APP_ALGOLIA_PEOPLE_INDEX_NAME || '');
  cachedPeopleIndex = index;
  cachedPeopleIndexKeysForInstance = algoliaKeys;
  return index;
};

const getCompaniesIndex = async (isSort = false, keys) => {
  // If keys not provided, incomplete, or empty object, fetch them
  // Treat empty object {} the same as undefined/null to avoid unnecessary fetches
  let algoliaKeys = keys;
  if (!algoliaKeys || !algoliaKeys.appId || !algoliaKeys.searchApiKey) {
    try {
      algoliaKeys = await getAlgoliaKeys();
    } catch (error) {
      // If getAlgoliaKeys throws (e.g., backend unavailable), return null for graceful degradation
      console.warn('[Algolia] Failed to fetch keys for companies index:', error);
      return null;
    }
  }
  
  // Return null instead of throwing to maintain backward compatibility and allow graceful degradation
  // searchClient handles null indices by returning empty results
  if (!algoliaKeys?.appId || !algoliaKeys?.searchApiKey) {
    console.warn('[Algolia] Algolia keys not available for companies index. Returning null for graceful degradation.');
    return null;
  }
  
  const client = algoliaClient(algoliaKeys.appId, algoliaKeys.searchApiKey);
  if (!client) return null;
  return client.initIndex(
    isSort ? process.env.REACT_APP_ALGOLIA_COMPANIES_INDEX_ASC : process.env.REACT_APP_ALGOLIA_COMPANIES_INDEX || ''
  );
};
export { getProjectIndex, getCastingIndex, getPeopleIndex, getCompaniesIndex };
